export default __webpack_public_path__ + "static/media/red-right.d98e55d7.svg";